import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation } from 'jotai-tanstack-query';

import { putAdjustLeverageApi } from '@flipster/apis/v2/trade';
import { snackbar } from '@flipster/react/design-system/snackbar';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getErrorMessage } from '@flipster/utils/error';

import { tradeRequestBaseBunja } from '../base-params';

interface AdjustLeverageVariables {
  symbol: string;
  slot: number;
  leverage: number;
}

/**
 * 포지션 레버리지 조정 액션 (구 apps/web useAdjustLeverageModal의 실행 로직).
 * 에러는 스낵바 표시 후 rethrow — 호출측(모달)이 열림 상태를 유지할 수 있게 한다.
 */
export const adjustLeverageActionBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { getBase } = bunja.use(tradeRequestBaseBunja);

  const putAdjustLeverageApiAtom = atomWithMutation(() => ({
    mutationKey: ['putAdjustLeverageApi'],
    mutationFn: ({ symbol, slot, leverage }: AdjustLeverageVariables) =>
      putAdjustLeverageApi(symbol, slot, { ...getBase(), leverage }),
  }));

  const isAdjustLeverageLoadingAtom = atom((get) => get(putAdjustLeverageApiAtom).isPending);

  const adjustLeverage = async (symbol: string, slot: number, leverage: number): Promise<void> => {
    try {
      await store.get(putAdjustLeverageApiAtom).mutateAsync({ symbol, slot, leverage });
    } catch (error) {
      snackbar.error({ message: getErrorMessage(error) });
      throw error;
    }
  };

  return { adjustLeverage, isAdjustLeverageLoadingAtom };
});
adjustLeverageActionBunja.debugLabel = 'adjustLeverageActionBunja';
